const BO=()=> {

return(
<>

<div className="d-flex justify-content-center">
  <div className="card ">
        
        <div className="card-body">
          <h5 className="h1">MSBTE MCQ</h5>
          <p className="card-text">Download Study Resources | DIPLOMA Engineering PORTAl for MSBTE MCQ Question Banks</p>
          <a href="https://www.cwipedia.in" className="btn btn-primary">#HOME</a>
          <br/>
         
        </div>
      </div></div>

<div className="dashboard">


  
      <div className="container px-2 ">
        <div className="row gx-3 ">

        <div className="row gx-3 ">
            <div className="col dash">
             <a href="https://www.cwipedia.in/p/msbte-mcqs.html"><div className="p-3 border1 ">6th SEM MCQs</div></a>
            </div>
            <div className="col dash">
              <a href="https://www.cwipedia.in/p/msbte-computer-engineering-group-mcqs.html"><div className="p-3 border1">MSBTE MCQ Question Banks</div></a>
            </div>
          </div>

          <div className="col dash">
           <a href="https://www.cwipedia.in/p/msbte-model-answer.html"><div className="p-3 border1 ">Model Answer Paper</div></a>
          </div>
          <div className="col dash">
            <a href="https://www.cwipedia.in/p/blog-page.html"><div className="p-3 border1">Sample Question Paper</div></a>
          </div>
        </div>

        <div className="row gx-3 ">
            <div className="col dash">
             <a href="https://www.cwipedia.in/p/msbte-i-scheme-syllabus-for-all-diploma.htm"><div className="p-3 border1 ">Syllabus</div></a>
            </div>
            <div className="col dash">
              <a href="https://www.cwipedia.in/search/label/Notes"><div className="p-3 border1">Ref (Notes) </div></a>
            </div>
          </div>

          <div className="row gx-3 ">
            <div className="col dash">
             <a href="https://www.cwipedia.in/2021/04/msbte-manual-i-scheme.html"><div className="p-3 border1 ">Manuals</div></a>
            </div>
            <div className="col dash">
              <a href="https://www.cwipedia.in/search/label/MSBTE/"><div className="p-3 border1">MSBTE</div></a>
            </div>
          </div>

          <div className="row gx-3 ">
            <div className="col dash">
             <a href="https://www.cwipedia.in/search/label/Com"><div className="p-3 border1 ">Computer</div></a>
            </div>
            <div className="col dash">
              <a href="https://www.cwipedia.in/"><div className="p-3 border1">MORE</div></a>
            </div>
          </div>


          <div className="row gx-3 ">
            <div className="col dash">
            <a href='https://play.google.com/store/apps/details?id=in.cwipedia.msbtepracticecwipedia'>
        <img class='playlogo img-fluid' loading='lazy' src='https://lh3.googleusercontent.com/cjsqrWQKJQp9RFO7-hJ9AfpKzbUb_Y84vXfjlP0iRHBvladwAfXih984olktDhPnFqyZ0nu9A5jvFwOEQPXzv7hr3ce3QVsLN8kQ2Ao=s0'/>
        </a>
            </div>
          </div>

        

          <footer>
        <div className="container d-flex justify-content-center">
          
            <hr />
            <p >
                Copyright 2017-2021 Some rights reserved | <a href='https://www.cwipedia.in/' >cwipedia.in</a>
          </p>
        </div>
      </footer>

      </div>

     
      </div>


     
      
     


</>
 
)

}

export default BO;